import { useCallback } from 'react';
import { useHistory, useLocation, Link as RouterLink } from 'react-router-dom';
import {containsLocale} from '../utils';
import {useLocale} from '../Locale';
import I18n from './I18n';
import GlobalEvents from '../GlobalEvents';
import { useAnalyticsContext } from './AnalyticsContext';
import { trackClick } from '../adobeAnalytics';

export function EventTracker(props){
	const { text: pText, component: Component, external, destination, newTab, onClick, ...rest } = props;
	const analytics = useAnalyticsContext();
	const locale = useLocale();
	const text = pText != null ? (I18n.getTranslation(locale, pText) || pText) : null;

	const handleClick = useCallback(async (e) => {
		trackClick(analytics.componentName, text, destination, analytics.locationInPage, external);
		onClick?.(e, analytics);
	}, [analytics, destination, external, onClick, text]);

	if(newTab){
		return <Component {...rest} target='_blank' onClick={handleClick}>{text}</Component>;	
	}
	return <Component {...rest} onClick={handleClick}>{text}</Component>;
}

export function Button(props){
	return <EventTracker component="button" external={false} destination={null} {...props} />;
}

export default function Link(props) {
	const { href: pHref, transition, newTab, ...rest } = props;
	const history = useHistory();
	const locale = useLocale();
	
	const absolute = pHref.indexOf('http') === 0;
	const external = absolute && pHref.indexOf(window.location.host) === -1
	const href = absolute || containsLocale(pHref) ? pHref : `/${locale}/${pHref}`;

	const onClick = useCallback(
		(e) => {
			if (absolute !== true && transition === true) {
				e.preventDefault();
				
				let timeout = null;

				function transition(){
					clearTimeout(timeout);
					GlobalEvents.off('TransitionVideo.onended', onEnded);

					history.push(href);
				}
				
				function onEnded(){
					transition();
				}

				GlobalEvents.on('TransitionVideo.onended', onEnded);

				timeout = setTimeout(() => {
					transition();
				}, 1000);

				GlobalEvents.emit('Link.play');
			}
		},
		[absolute, history, href, transition],
	);

	if (absolute) {
		return <EventTracker component="a" rel="noreferrer" external={external} newTab={newTab} destination={href} href={href} onClick={onClick} {...rest} />;
	} else {
		return <EventTracker component={RouterLink} to={href} external={false} newTab={newTab} destination={href} onClick={onClick} {...rest} />;
	}
}